import { render, staticRenderFns } from "./DeviceMonitorMetrics.vue?vue&type=template&id=024f89b3&scoped=true"
import script from "./DeviceMonitorMetrics.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorMetrics.vue?vue&type=script&lang=js"
import style0 from "./DeviceMonitorMetrics.vue?vue&type=style&index=0&id=024f89b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f89b3",
  null
  
)

export default component.exports